import { fromJS } from 'immutable';

import {
  REQUEST_SEARCHES_REQUIRING_ATTENTION,
  REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS,
  REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: { loading: false, error: false },
});

export function searchesRequiringAttentionRequest() {
  return {
    type: REQUEST_SEARCHES_REQUIRING_ATTENTION,
  };
}

export function searchesRequiringAttentionSuccess(response) {
  return {
    type: REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS,
    response,
  };
}

export function searchesRequiringAttentionFailure(error) {
  return {
    type: REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE,
    error,
  };
}

export default function searchesRequiringAttentionReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_SEARCHES_REQUIRING_ATTENTION:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );
    default:
      return state;
  }
}
